import { Component, ViewEncapsulation, ViewChild, TemplateRef, Renderer2 } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { ActivityGridComponent } from '../../activity-grid/activity-grid.component';
import { forkJoin, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AuService } from '../au.service';
import { MsalService } from '@azure/msal-angular';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { AuFindingsComponent } from '../au-findings/au-findings.component';
import { RiskComponent } from '../../risk/risk.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { AddMapCapaComponent } from '../../add-map-capa/add-map-capa.component';
import { ModuletypeComponent } from 'src/app/moduletype/moduletype.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-au-finding-details',
  templateUrl: './au-finding-details.component.html',
  styleUrls: ['./au-finding-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AuFindingDetailsComponent {
  infoIconSrc: string = 'src/assets/img/info-yellow.png';
  isProcessing = true;
  findingsDetailsData: any = {};
  isDataLoaded: boolean = false;
  objForDocuments: any;
  isAdEnabled: boolean = false;

  severityTxt: any;
  assignedToUserTxt: any;
  assignedToDepartmentTxt: any;
  capaGroupTxt: any;
  departmentCodeTxt: any;
  responseReviewUserTxt: any;
  implementationReviewerUserText: any;
  peerReviewersList: any = [];
  isPeerReviewer: boolean = false;
  triggerAesthetic: boolean = false;
  findingsList: [];
  viewingSequence: number;
  loadRisk: boolean = false;
  dueDateDisableFlag: boolean = false;
  closureDateDisableFlag: boolean = false;
  selectedCapaCount: number = 0;

  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  }

  constructor(
    public readonly router: Router,
    public readonly dialog: MatDialog,
    public readonly auService: AuService,
    public readonly appService: AppService,
    public readonly message: messageService,
    public readonly qualityService: qmsService,
    public readonly paginationService: PaginationService,
    public readonly auFindingsComponent: AuFindingsComponent,
    public readonly activityGridComponent: ActivityGridComponent,

    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly authService: MsalService,
    private readonly riskComponent: RiskComponent
  ) {
    const now = new Date();
    this.isAdEnabled = localStorage.getItem("adEnabled") == 'Y';
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.viewingSequence = this.auService.findingsData.SEQ;
    this.appService.getAllAuFindingsByAuNo(this.message.activityId).subscribe((data: any) => {
      this.findingsList = data;
    });
  }

  backward() {
    this.loadRisk = false;
    const finding = this.findingsList.find((findings: any) => findings.seq == this.viewingSequence - 1) as any;
    if (finding) {
      this.viewingSequence = this.viewingSequence - 1;
      console.log(finding);
      this.auService.findingId = finding.findingId;
      this.auService.findingsData = finding;
      this.ngOnInit();
    } else {
      console.warn('No previous finding found');
    }
  }

  forward() {
    this.loadRisk = false;
    const finding = this.findingsList.find((findings: any) => findings.seq == this.viewingSequence + 1) as any;
    if (finding) {
      this.viewingSequence = this.viewingSequence + 1;
      console.log(finding);
      this.auService.findingId = finding.findingId;
      this.auService.findingsData = finding;
      this.ngOnInit();
    } else {
      console.warn('No next finding found');
    }
  }

  first() {
    this.loadRisk = false;
    const finding = this.findingsList.find((findings: any) => findings.seq == 1) as any;
    if (finding) {
      this.viewingSequence = 1;
      console.log(finding);
      this.auService.findingId = finding.findingId;
      this.auService.findingsData = finding;
      this.ngOnInit();
    }
  }

  last() {
    this.loadRisk = false;
    const finding = this.findingsList.find((findings: any) => findings.seq == this.findingsList.length) as any;
    if (finding) {
      this.viewingSequence = this.findingsList.length;
      console.log(finding);
      this.auService.findingId = finding.findingId;
      this.auService.findingsData = finding;
      this.ngOnInit();
    }
  }

  focusMethod(value: any) {
    setTimeout(() => {
      const requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  selectedSeverity: any = null;
  selectedAssignedToUser: any = null;
  selectedAssignedToDepartment: any = null;
  selectedCapaGroup: any = null;

  dropDownForSeverity: any = [];
  dropDownForAssignedToUser: any = [];
  dropDownForDepartmentCode: any = [];
  dropDownForCapaGroup: any = [];

  severityDropdown: any = [];
  assignedToUserDropDown: any = [];
  departmentCodeDropdown: any = [];
  capaGroupDropDown: any = [];
  selectedResponseReviewUser: any = null;
  selectedImplementationReviewerUser: any = null;
  displaySaveButton: any;
  tempAuditStatus: any = "";

  isSeverityOdd: any = null;
  isAssignedToUserOdd: any = null;
  isAssignedToDepartmentOdd: any = null;
  isResponseReviewUserOdd: any = null;
  isImplementationReviewerUserOdd: any = null;

  requestedAtSearchText: string = '';
  businessAreaSearchText: string = '';
  isRequestedAtOdd: any = null;
  selectedBusinessArea: any = [];
  requestedAtList: any = [];
  businessAreaList: any = [];
  requestedAtDropdown: any = [];
  businessAreaDropdown: any = -[];

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    this.dynamicLabelCall();
    this.message.isfindingsFrom = "AUF";
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
    this.message.showDocumentActionButtons = true;
    this.tempAuditStatus = this.qualityService.activity.status ?? this.tempAuditStatus;


    const activityId = this.message.activityId;
    const findingId = this.auService.findingId;
    const groupId = this.qualityService.selectedActivityGroupId;
    const groupDetailId = this.qualityService.selectedGroupDetailData.groupDetailId;
    const module = this.qualityService.moduleName;

    const getCapaGroups$ = this.appService.getGroupsModuleCurrentUserVw("CAPA");
    const getSeverity$ = this.appService.getCodeListsByGroup("SEVERITY");
    const getParticipants$ = this.appService.getAuParticipantsByAuNo(activityId);
    const getResponseReview$ = this.appService.getQmsActiveGroupUsers(groupId, module, 'Response Reviewer');
    const getImplementationReview$ = this.appService.getQmsActiveGroupUsers(groupId, module, 'Implementation Reviewer');
    const reportTemplate$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId("AU", 0);
    const businessArea$ = this.appService.getQmsBusinessAreasByModule('AU');



    this.objForDocuments = { id: this.auService.findingId, pagename: "Audit Finding" }

    forkJoin([
      getCapaGroups$,
      getSeverity$,
      getParticipants$,
      getResponseReview$,
      getImplementationReview$,
      reportTemplate$,
      businessArea$
    ]).pipe(
      switchMap((
        [capaGroupsData, severityData, participantsData, responseReviewData, implementationReviewData, reportTemplate, businessArea]
      ) => {
        this.dropDownForCapaGroup = capaGroupsData;
        this.selectBoxForCapaGroup();

        this.dropDownForSeverity = severityData;
        this.selectBoxForSeverity();

        this.dropDownForAssignedToUser = participantsData;
        this.selectBoxForResponsibilityUserList();
        this.dropDownDataForReportTemplate = reportTemplate;
        this.selectBoxForReportTemplate();
        const foundPrimaryContactData = this.dropDownForAssignedToUser.find((item: any) => item.isPrimaryContact == 'Y');
        if (foundPrimaryContactData) {
          this.auService.isAuditee = foundPrimaryContactData.applicationUserId == this.message.getUserId();
        }
        this.responseReviewUserList = responseReviewData;
        this.selectResponseReview();

        this.implementationReviewerUserList = implementationReviewData;
        this.selectImplementationReviewer();

        this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
        this.selectBoxForDepartmentCode();

        this.requestedAtList = businessArea ?? [];
        this.requestedAtList && this.selectBoxForRequestedAt();

        return this.appService.getAuFindingByFindingId(findingId);
      })
    ).subscribe((data: any) => {
      this.isProcessing = false;
      data.expectedCaClosureDate = data.expectedCaClosureDate ? new Date(data.expectedCaClosureDate) : null;
      data.expectedPaClosureDate = data.expectedPaClosureDate ? new Date(data.expectedPaClosureDate) : null;
      data.expectedClosureDate = data.expectedClosureDate ? new Date(data.expectedClosureDate) : null;
      data.actualClosedDate = data.actualClosedDate ? new Date(data.actualClosedDate) : null;
      data.responseReviewRejectedOn = data.responseReviewRejectedOn ? new Date(data.responseReviewRejectedOn) : null;
      data.responseVerificationRejectedOn = data.responseVerificationRejectedOn ? new Date(data.responseVerificationRejectedOn) : null;
      data.implementationVerificationRejectedOn = data.implementationVerificationRejectedOn ? new Date(data.implementationVerificationRejectedOn) : null;
      data.implementationReviewRejectedOn = data.implementationReviewRejectedOn ? new Date(data.implementationReviewRejectedOn) : null;


      data.dueDate = data.dueDate ? new Date(data.dueDate) : null;
      this.auService.finalRiskScore = data.finalRiskScore;
      this.auService.finalRiskStatus = data.finalRiskStatus;
      this.auService.finalRiskComments = data.finalRiskComments;
      this.findingsDetailsData.leadAuditor = data.leadAuditor;
      this.findingsDetailsData.assignedToUser = data.assignedToUser;
      this.setUpdateType(data.status);

      this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && data.requestedAt && this.onRequestedAtSelect(this.event, { valueExp: data.requestedAt, displayExp: data.requestedAt });

      if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && data.requestedAt) {
        const matchingRequestedAt = this.requestedAtList?.find((item: any) => item.taskRequestedAt === data.requestedAt);
        if (!matchingRequestedAt) {
          this.isRequestedAtOdd = data.requestedAt;
          this.requestedAtDropdown.push({
            valueExp: data.requestedAt,
            displayExp: data.requestedAt
          })
        }

        setTimeout(() => {
          if (this.businessAreaDropdown.length) {
            this.selectedBusinessArea = data.coreBusinessAreaName.split(',');
            this.isAllBusinessAreaSelected = this.selectedBusinessArea == this.businessAreaDropdown.length;
          } else {
            [this.selectedBusinessArea, this.isAllBusinessAreaSelected] = [[], false];
          }
        }, 1500)
      }

      if (data.severity) {
        const matchingAuditSeverity = this.severityDropdown?.find((item: any) => item.valueExp == data.severity)
        if (matchingAuditSeverity) {
          this.selectedSeverity = matchingAuditSeverity.valueExp;
          this.isSeverityOdd = null;
        } else {
          this.severityDropdown.push({
            valueExp: data.severity,
            displayExp: data.severity
          });
          this.isSeverityOdd = this.selectedSeverity = data.severity;
        }
      }

      if (data.assignedToDepartment) {
        const matchingAuditDepartment = this.departmentCodeDropdown?.find((item: any) => item.valueExp == data.assignedToDepartment)
        if (matchingAuditDepartment) {
          this.selectedAssignedToDepartment = matchingAuditDepartment.valueExp;
          this.isAssignedToDepartmentOdd = null;
        } else {
          this.departmentCodeDropdown.push({
            valueExp: data.assignedToDepartment,
            displayExp: data.assignedToDepartment
          });
          this.isAssignedToDepartmentOdd = this.selectedAssignedToDepartment = data.assignedToDepartment;
        }
      }

      this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId).subscribe((response: any) => {
        console.log("data.severity=", data.severity);
        for (let i = 0; i < response.length; i++) {
          console.log("response[i].type=", response[i].type);
          if (response[i].type == ("Findings-" + data.severity)) {
            console.log("response.toBeStartedInDays=", response[i].toBeStartedInDays);
            console.log("response.toBeClosedInDays=", response[i].toBeClosedInDays);
            if (response[i].toBeStartedInDays) {
              this.dueDateDisableFlag = true;
            } else {
              this.dueDateDisableFlag = false;
            }
            if (response[i].toBeClosedInDays) {
              this.closureDateDisableFlag = true;
            } else {
              this.closureDateDisableFlag = false;
            }
          }
        }

      });


      this.auService.isAssignedUser = data.assignedToUser == this.message.getUserId();
      this.auService.responseReviewedByUser = data.responseReviewedByUser == this.message.getUserId();
      this.auService.implementationReviewedByUser = data.implementationReviewedByUser == this.message.getUserId();

      if (this.auService.isAuditor) {
        if (data.status == 'Open' && this.qualityService.activity.status == 'In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Open' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Pending Response Verification' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Pending Implementation Verification' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else {
          this.displaySaveButton = false;
        }
      } else if (this.auService.isAuditee) {
        if (data.status == 'Open' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Response Review Rejected' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Response Verification Rejected' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Response Accepted/Implementation Pending' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Implementation Review Rejected' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else if (data.status == 'Implementation Verification Rejected' && this.qualityService.activity.status == 'Findings In Progress') {
          this.displaySaveButton = true;
        } else {
          this.displaySaveButton = false;
        }
      }

      if ((data.status == 'Open' || data.status == 'Response Review Rejected' || data.status == 'Response Verification Rejected') && this.auService.isAssignedUser) {
        this.expectedCloseDateForAuditee = true;
        this.ResponseDateForAuditee = true;
      } else if ((
        data.status == 'Response Accepted/Implementation Pending' || data.status == 'Implementation Review Rejected' || data.status == 'Implementation Verification Rejected')
        && this.auService.isAssignedUser) {
        this.expectedCloseDateForAuditee = true;
        this.ResponseDateForAuditee = false;
      } else {
        this.ResponseDateForAuditee = false;
        this.expectedCloseDateForAuditee = false;
      }

      if (data.assignedToUser) {
        const matchingAuditUser = this.assignedToUserDropDown?.find((item: any) => item.valueExp == data.assignedToUser)
        if (matchingAuditUser) {
          this.selectedAssignedToUser = matchingAuditUser.valueExp;
          this.isAssignedToUserOdd = null;
        } else {
          this.assignedToUserDropDown.push({
            valueExp: data.assignedToUser,
            displayExp: data.assignedToUser
          });
          this.isAssignedToUserOdd = this.selectedAssignedToUser = data.assignedToUser;
        }
      }

      if (data.responseReviewedByUser == 0) {
        this.selectedResponseReviewUser = data.responseReviewedByUser;
      } else if (data.responseReviewedByUser) {
        const matchingResponseReviewer = this.responseReviewDropdown.find((item: any) => item.valueExp == data.responseReviewedByUser);
        if (matchingResponseReviewer) {
          this.selectedResponseReviewUser = matchingResponseReviewer.valueExp;
          this.isResponseReviewUserOdd = null;
        } else {
          this.responseReviewDropdown.push({
            valueExp: data.responseReviewedByUser,
            displayExp: data.responseReviewer ? data.responseReviewer : data.responseReviewedByUserName
          });
          this.isResponseReviewUserOdd = this.selectedResponseReviewUser = data.responseReviewedByUser;
        }
      } else {
        this.selectedResponseReviewUser = null;
      }

      if (data.implementationReviewedByUser == 0) {
        this.selectedImplementationReviewerUser = data.implementationReviewedByUser;
      } else if (data.implementationReviewedByUser) {
        const matchingImplementationReviewer = this.implementationReviewerDropdown.find((item: any) => item.valueExp == data.implementationReviewedByUser);
        if (matchingImplementationReviewer) {
          this.selectedImplementationReviewerUser = data.implementationReviewedByUser;
          this.isImplementationReviewerUserOdd = null;
        } else {
          this.implementationReviewerDropdown.push({
            valueExp: data.implementationReviewedByUser,
            displayExp: data.implementationReviewer ? data.implementationReviewer : data.implementationReviewedByUserName
          });
          this.isImplementationReviewerUserOdd = this.selectedImplementationReviewerUser = data.implementationReviewedByUser;
        }
      } else {
        this.selectedImplementationReviewerUser = null;
      }

      if (data.isCapaRequired == 'Y') {
        data.isCapaRequired = data.isCapaRequired = true;
        this.findingsDetailsData.capaNo = data.capaNo;
      } else {
        data.isCapaRequired = data.isCapaRequired = false;
        this.findingsDetailsData.capaNo = null;
      }

      this.findingsDetailsData = {};
      this.findingsDetailsData = data;
      this.qualityService.currentFindings = data;
      // Update PA closure date configuration based on loaded CA closure date
      if (this.findingsDetailsData.expectedCaClosureDate) {
        this.onCaClosureDateChange(this.findingsDetailsData.expectedCaClosureDate);
      }

      if ((this.findingsDetailsData.status == 'Open' || this.findingsDetailsData.status == 'Response Verification Rejected' || this.findingsDetailsData.status == 'Response Review Rejected')
        && (this.auService.isAssignedUser || this.auService.isAuditee)) {
        this.editableCapa = true;
      } else {
        this.editableCapa = false;
      }

      this.getDynamicButtons();
      this.isDataLoaded = true;

      this.peerReviewersList = [];
      this.appService.getTaskStagesForFindings(this.qualityService.activityId, 0).subscribe((taskStages: any[]) => {
        if (taskStages.length > 0) {
          const stageUserCalls = taskStages.map(taskStage => this.getUsersForStages(taskStage));

          forkJoin(stageUserCalls).subscribe(() => {
            this.triggerAesthetic = true;
            this.triggerFindingsAesthetic();
          });
        } else {
          this.triggerFindingsAesthetic();
        }
      });
      setTimeout(() => {
        this.selectedTabName == "Risk Assessment" && (this.loadRisk = true);
      })
    }, (error) => {
      this.isProcessing = false;
    })
    this.ngOnChangesReport();
    this.reportFooterDropdown = [];
    this.ngOnChangesReportFooter();
  }
  ngOnChangesReport() {
    this.message.breadcrumbData.thirdLevel = "";
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe((data: any) => {
      this.organizationReportImageDetails = data;
      this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qualityService.selectedActivityGroupId).subscribe((data: any) => {
        this.dropDownDataForReportLogo = data;
        this.selectBoxForReportLogo();
        this.isProcessing = false;
      });
    }, (error: any) => {
      this.isProcessing = false;
    })
  }
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (let j = 0; j < this.organizationReportImageDetails.length; j++) {
              if (this.organizationReportImageDetails[j].reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: this.organizationReportImageDetails[j].reportImageId,
                  displayExp: this.organizationReportImageDetails[j].reportImageName
                });
              }

            }
          }
        }
      } else {
        for (let j = 0; j < this.organizationReportImageDetails.length; j++) {
          if (this.organizationReportImageDetails[j].reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: this.organizationReportImageDetails[j].reportImageId,
              displayExp: this.organizationReportImageDetails[j].reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (let j = 0; j < this.reportLogoDropdown.length; j++) {
          if (this.reportLogoDropdown[j].valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = this.reportLogoDropdown[j].valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe(
      (data: any) => {
        this.reportFooterDropdown1 = data;
        console.log("data", this.reportFooterDropdown1);
        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
        this.isProcessing = false;
      },
      (error: any) => {
        this.isProcessing = false;
      }
    );
  }

  private selectBoxForRequestedAt(): void {
    this.requestedAtDropdown = this.requestedAtList?.filter((x: any) => x.module == 'AU')?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  public onRequestedAtSelect(event: any, item: any): void {
    if (event.isUserInput) {
      this.handleDropDownValidation('requested-at', item);

      if (item) {

        this.findingsDetailsData.requestedAtName = item.displayExp;
        const getBusinessArea = this.requestedAtList?.find((x: any) => x.taskRequestedAt == item.displayExp);
        [this.businessAreaList, this.selectedBusinessArea, this.findingsDetailsData.coreBusinessAreaName] = [[], [], null];
        this.businessAreaList = getBusinessArea?.listOfBusinessArea?.split(',');
        this.selectBoxForBusinessArea();

      } else {

        this.businessAreaList = [];
        this.businessAreaDropdown = [];
        this.findingsDetailsData.requestedAtName = '';
      }
    }
  }

  private selectBoxForBusinessArea(): void {
    this.businessAreaDropdown = this.businessAreaList?.map((bArea: any) => ({
      valueExp: bArea,
      displayExp: bArea
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  isAllBusinessAreaSelected?: boolean = false
  public onBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('business-area', this.selectedBusinessArea)
        this.isAllBusinessAreaSelected = this.businessAreaDropdown.length == this.selectedBusinessArea.length;
      });
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  public toggleAllBusinessArea(): void {
    if (this.isAllBusinessAreaSelected) {
      for (const item of this.businessArea.options) item.select();
    } else {
      for (const item of this.businessArea.options) item.deselect();
      this.selectedBusinessArea = [];
    }

    setTimeout(() => { this.handleDropDownValidation('business-area', this.selectedBusinessArea); });
  }

  public getTooltip(): string {
    return this.selectedBusinessArea.join(',');
  }

  label: any = [];
  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.label = [];
    this.dynamicLabel = null;
    const data = {
      gridName: 'AU_FINDINGS',
      tableName: 'QMS_AU_FINDINGS_VW',
      moduleName: this.qualityService.moduleName,
      groupId: this.qualityService.selectedGroup,
      forLabel: "Y"
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  expectedCloseDateForAuditee: boolean = false;
  ResponseDateForAuditee: boolean = false;
  editableCapa: boolean;
  auditeeEditable: boolean;
  selectBoxForCapaGroup() {
    this.capaGroupDropDown = this.dropDownForCapaGroup?.map((item: any) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    }));
  }

  selectBoxForDepartmentCode() {
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  selectBoxForSeverity() {
    this.severityDropdown = this.dropDownForSeverity?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }

  selectBoxForResponsibilityUserList() {
    this.assignedToUserDropDown = this.dropDownForAssignedToUser?.filter((item: any) => item.applicationUserId !== null)
      ?.map((item: any) => ({
        valueExp: item.applicationUserId,
        displayExp: item.userName
      }));
  }

  responseReviewUserList: any = [];
  responseReviewDropdown: any = [];
  selectResponseReview() {
    this.responseReviewDropdown = this.responseReviewUserList?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    }));
  }

  implementationReviewerUserList: any = [];
  implementationReviewerDropdown: any = [];
  selectImplementationReviewer() {
    this.implementationReviewerDropdown = this.implementationReviewerUserList?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    }));
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  futureDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date(),
  }

  $get_ca_pa_dynamic_config() {
    return {
      dateInputFormat: this.dateFormat,
      showWeekNumbers: false,
      containerClass: 'theme-dark-blue',
      showTodayButton: false,
      todayPosition: 'center',
      minDate: new Date(),
      maxDate: this.findingsDetailsData.expectedClosureDate ? new Date(this.findingsDetailsData.expectedClosureDate) : undefined,
    }
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Finding': this.dynamicLabel?.['FINDING']?.fieldName,
      'Reference': this.dynamicLabel?.['REFERENCE']?.fieldName,
      'Deliverables': this.dynamicLabel?.['DELIVERABLES']?.fieldName,
      'Additional Field': this.dynamicLabel?.['ADDITIONAL_FIELD']?.fieldName,
      'Auditor Comments': this.dynamicLabel?.['AUDITOR_COMMENTS']?.fieldName,
      'Root Cause Analysis': this.dynamicLabel?.['ROOT_CAUSE_ANALYSIS']?.fieldName,
      'Immediate Correction': this.dynamicLabel?.['IMMEDIATE_CORRECTION']?.fieldName,
      'Corrective Action': this.dynamicLabel?.['CORRECTIVE_ACTION']?.fieldName,
      'Preventive Action': this.dynamicLabel?.['PREVENTIVE_ACTION']?.fieldName,
      'Comments': this.dynamicLabel?.['COMMENTS']?.fieldName,
      'Assigned To User Details': this.dynamicLabel?.['ASSIGNED_TO_USER_DETAILS']?.fieldName,
      'Closure Comments': this.dynamicLabel?.['CLOSURE_COMMENTS']?.fieldName,
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.findingsDetailsData[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.findingsDetailsData[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };


  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = !this.isContentEmpty(items) ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'initial-complaint-category-validation' || fieldId === 'final-complaint-category-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  onFieldFocusout() {

  }

  //finding dynamic btn
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  isEsignRequired: boolean;
  isReasonSignReqd: boolean;
  buttonLabel: any;
  reason: any;
  userName: any;
  password: any = "";
  reviewStatus: any;
  confirmWithReasonPopupConfig = {
    width: this.getWidth(),
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  getWidth() {
    if (this.buttonLabel?.length < 30) {
      return '550px'
    } else if (this.buttonLabel?.length < 50) {
      return '650px'
    } else {
      return '800px'
    }
  }

  selectedStatus: any = null;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleValidationConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmValidationPopup', { static: true }) confirmValidationPopup: TemplateRef<any>;

  @ViewChild('searchCapaRequired', { static: true }) searchCapaRequired: TemplateRef<any>;
  visibleSearchCapaRequiredPopup: MatDialogRef<TemplateRef<any>>;
  confirmValidationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  capaPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  confirmValidationOkFunc() {
    this.visibleValidationConfirm.close();
  };

  buttonList: any;
  noteResult: any;
  getDynamicButtons() {
    this.buttonList = [];
    const obj = {
      findingId: this.findingsDetailsData.findingId,

    }
    this.appService.getFindingsButtons(obj).subscribe((data: any) => {
      this.showsavebtn = false;
      if (data.labelsResult != null) {
        if (this.auService.auditPageFrom == "Main" || this.router.url.includes("auFindingDetails")) {
          data.labelsResult = data.labelsResult + ",Cancel";
        } else if (this.auService.auditPageFrom == "MyTask") {
          data.labelsResult = data.labelsResult;
        }

        this.buttonList = data.labelsResult.split(",");
        for (let k = 0; k < this.buttonList.length; k++) {
          if (this.buttonList[k] == "Save") {
            this.showsavebtn = true;
            this.buttonList.splice(k, 1);
          }
        }
      } else {
        if (this.auService.auditPageFrom == "Main" || this.router.url.includes("auFindingDetails")) {
          data.labelsResult = "Cancel";
        } else if (this.auService.auditPageFrom == "MyTask") {

        }
        this.buttonList = data.labelsResult.split(",");
      };
      this.noteResult = data.noteResult;;
    });
  }

  cancelValidationConfirmFunc() {
    this.visibleValidationConfirm.close();
  };

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qualityService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qualityService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  showsavebtn: any = false;
  triggeredThroughDynBtn: boolean = false;
  async dynamicButtonClick(button: any) {

    if (this.qualityService.activity.status == "Findings In Progress" && await this.qualityService.validateExtension({ refNo: this.qualityService.activityId, extensionFor: "Findings", subTaskNo: this.findingsDetailsData.findingId })) {
      setTimeout(() => {
        this.showSnackBar(this.qualityService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }
    this.buttonLabel = button;
    if (button == "Review Response") {
      this.reviewStatus = ['Reviewed', 'Review Rejected'];
    } else if (button == "Approve") {
      this.reviewStatus = ['Approved', 'Approval Rejected'];
    } else if (button == "Verify Response") {
      if (this.findingsDetailsData.isCapaRequired) {
        this.reviewStatus = ['Accept Response', 'Response Verification Rejected'];
      } else {
        this.reviewStatus = ['Accept Response', 'Response Verification Rejected', 'Accept Response/No Implementation Required'];
      }
    } else if (button == "Verify Implementation") {
      this.reviewStatus = ['Accept Implementation', 'Implementation Verification Rejected'];
    } else if (button == "Review Implementation") {
      this.reviewStatus = ['Reviewed', 'Review Rejected'];
    }
    this.selectedStatus = null;
    this.reason = "";
    this.password = "";
    this.userName = localStorage.getItem("loggedUserName");
    this.isEsignRequired = false;
    this.isReasonSignReqd = true;
    this.isEsignRequired = true;
    this.changetypeAddAndEditPassword = true;

    this.triggeredThroughDynBtn = true;
    if (button != "Obsolete") {
      this.saveFindingDetails(this.findingsDetailsData).then((isValid: boolean) => {
        if (button == "Submit for Response Review" || button == "Re-Submit for Response Review" || button == "Review Response" || button == "Submit for Implementation Review" || button == "Re-Submit for Implementation Review" || button == "Verify Response" || button == "Verify Implementation" || button == "Submit to Auditor(Response Verification)" || button == "Re-Submit to Auditor(Response Verification)") {
          if (isValid) {
            this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
          }
        } else {
          this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
        }
      })
    } else {
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    }

  }

  onPasswordFieldFocusout() {
    if (this.passwordFieldValue != undefined) {
      if (this.password == '' || this.password == undefined || this.password == null) {
        this.passwordFieldValue.style.color = 'red';
      } else {
        this.passwordFieldValue.style.color = '#005c8a';
      }
    }
  }

  passwordFieldValue: any;
  reviewUserFieldValue: any;
  approverUserFieldValue: any;
  reviewAndapproveToggleValue: any;
  reasonFieldValue: any;
  dynamicButtonFieldValidation() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.reviewUserFieldValue = document.getElementById('reviewUser-validation') as HTMLInputElement;
    this.approverUserFieldValue = document.getElementById('approverUser-validation') as HTMLInputElement;
    this.reviewAndapproveToggleValue = document.getElementById('reviewAndapprove-validation') as HTMLInputElement;
    this.reasonFieldValue = document.getElementById('reason-validation') as HTMLInputElement;

    if (this.password == '' || this.password == undefined || this.password == null) {
      this.passwordFieldValue.style.color = 'red';
    } else {
      this.passwordFieldValue.style.color = '#005c8a';
    }

    if (this.buttonLabel == "Review Response" || this.buttonLabel == "Approve" ||
      this.buttonLabel == 'Verify Response' || this.buttonLabel === 'Verify Implementation') {
      if (this.selectedStatus == null) {
        this.reviewAndapproveToggleValue.style.color = 'red';
      } else {
        this.reviewAndapproveToggleValue.style.color = '#005c8a';
      }
      if (this.reason == '' || this.reason == undefined || this.reason == null) {
        this.reasonFieldValue.style.color = 'red';
      } else {
        this.reasonFieldValue.style.color = '#005c8a';
      }
    }
  }

  radioChange(event: any) {
    //console.log(event.value);
    if (this.reviewAndapproveToggleValue != undefined) {
      this.reviewAndapproveToggleValue.style.color = '#005c8a';
    }
  }

  getColor(status: any) {
    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      return 'red';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      return 'orange';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      return 'green';
    } else {
      return '#005c8a';
    }
  }
  idCall() {

  };

  confirmWithresonSussess() {
    let selectedStatus
    if (this.buttonLabel == "Review Response" || this.buttonLabel == "Approve" || this.buttonLabel == 'Verify Response' || this.buttonLabel === 'Verify Implementation' || this.buttonLabel == 'Review Implementation') {
      selectedStatus = this.selectedStatus
    } else {
      selectedStatus = this.buttonLabel
    }
    this.isProcessing = true;
    let data = {
      findingId: this.findingsDetailsData.findingId,
      currentStatus: this.findingsDetailsData.status,
      buttonOperation: selectedStatus,
      comments: this.reason,
    }
    this.appService.performFindingsAction(data).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        if (this.buttonLabel === "Delete") {
          this.auService.isFromFindingDetails = true;
          this.router.navigate(['dashboard/auDetailPage']);
        }
        this.getDynamicButtons();
        this.ngOnInit();
        this.visibleConfirmWithReason.close();
        this.isProcessing = true;
      }
      this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      this.snackbarRef.onAction().subscribe(() => {
        this.snackbarRef.dismiss();
      });
      this.isProcessing = false;
    })

  }

  authEnable(flag: string) {
    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            if (flag == "SubmitforReview") {
              this.confirmWithresonSussess();
            }
            this.isProcessing = false;

          } else {
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
        }
      });
  }
  confirmWithReasonFunc() {
    this.isProcessing = true;
    // Check if e-sign password is required
    const isPasswordRequired = (localStorage.getItem("adEnabled") !== 'Y') && (!this.password || this.password.trim() === '');

    // Always validate reason if rejection is selected
    const isReasonRequired = this.selectedStatus?.includes("Rejected") && (!this.reason || this.reason.trim() === '');

    if (isPasswordRequired || isReasonRequired) {
      this.dynamicButtonFieldValidation(); // Highlights fields red

      // Optional: Show alert or modal
      alert('Please enter all mandatory fields...');

      this.isProcessing = false;
      return;
    } else if (this.buttonLabel == "Submit for Review") {
    } else if (localStorage.getItem("adEnabled") == 'Y') {
      this.authEnable("SubmitforReview")

    } else {
      let datavalidation = {
        userName: this.userName,
        password: this.password,
      }
      this.isProcessing = true;
      this.appService.validateUser(datavalidation).subscribe((data1: any) => {
        if (data1.resultType == "S") {
          this.confirmWithresonSussess();
        } else {
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: data1.result,
              type: data1.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data1.resultType == 'S' ? 'Success' : 'Error',
          });
        }
      })
    }
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  cancelFindingDetails() {
    this.qualityService.moduleName = "AU";
    this.qualityService.activityId = this.message.activityId;
    if (this.auService.auditPageFrom == "Main" || this.router.url.includes("auFindingDetails")) {
      this.qualityService.activityDynamicButtonList = [];
      this.auService.isFromFindingDetails = true;
      this.router.navigate(['dashboard/auDetailPage']);
      this.qualityService.cancelButtonFrom = "Activity";
    }
  }

  selectedTabName: any;
  onTabClick(event: any) {
    this.selectedTabName = event.tab.textLabel
    if (event.tab.textLabel == "Map CAPA") {
      this.showUserSearchGrid = false;
      this.selectedTabName = event.tab.textLabel;
    } else {
      this.selectedCapaGroup = null;
      this.searchByDepartmentCode = null;
      this.showUserSearchGrid = true;
      this.selectedTabName = event.tab.textLabel;
    }

    if (event.tab.textLabel == "Risk Assessment") {
      (this.loadRisk = true);
    }
  }

  showUserSearchGrid: boolean;
  searchByDepartmentCode: any = null;
  popupTitle: any;
  visibleEditButton: boolean;
  operationFlag: any;
  tempauditdetails: any;
  openSearchCapaRequiredPopup() {
    this.qualityService.isCapaTriggeredFromFindingPage = false;
    this.skipValidationForCAPA = true;
    this.selectedCapaGroup = null;
    this.searchByDepartmentCode = null;
    this.showUserSearchGrid = true;
    this.qualityService.auFindings = true;
    this.selectedTabName = "Create CAPA";
    this.popupTitle = "CAPA";
    this.tempauditdetails = this.qualityService.tempactivitybuttonDetails = this.qualityService.activity;
    this.qualityService.tempselectedGroupDetailId = this.qualityService.selectedGroupDetailId;
    if (this.findingsData.finding != '') {
      this.qualityService.findingDetailsForCapaDescription = this.findingsDetailsData.finding;
    } else {
      this.qualityService.findingDetailsForCapaDescription = '';
    }
    this.findingInfo = this.qualityService.activity.auId + ' : ' + this.findingsDetailsData.finding;

    this.mapCapa();
    this.onSelectGroup('');
  }
  findingInfo: any;

  @ViewChild(AddMapCapaComponent) addMapCapaComponent!: AddMapCapaComponent;


  mapCapa() {
    this.message.isFromFindings = true;
    this.addMapCapaComponent.openPopup();
  }

  onCapaEmitted() {
    const capa = this.message.addMapCapaFindings;
    this.findingsDetailsData.capaNo = capa.capaNo;
    this.findingsDetailsData.capaDetails = capa.capaId + '(' + capa.status + ')';
    this.isProcessing = false;
    this.saveFindingDetails(this.findingsDetailsData);
  }

  unmapCapa() {
    this.findingsData.capaDetails = null;
  }

  onSelectGroup(item: any) {
    let groupId = document.getElementById("group-validation") as HTMLInputElement;
    if (groupId) {
      groupId.style.color = '#005c8a';
    }
  }

  findingsData: any = {};


  skipValidationForCAPA: boolean = false;

  cancelSearchCapaRequiredPopup() {
    this.qualityService.moduleName = "AU";
    this.qualityService.activity = this.tempauditdetails;
    this.qualityService.activityId = this.message.activityId;
    this.skipValidationForCAPA && (this.skipValidationForCAPA = false);
    if (this.operationFlag == 'ADD') {
      this.popupTitle = this.popupTitle == "CAPA" ? "Create Audit Findings" : "";
    } else {
      this.popupTitle = this.popupTitle == "CAPA" ? "Update Audit Findings" : "";
    }
    this.visibleSearchCapaRequiredPopup.close();
  }

  detailsData(data: any, idx: any) {
    this.auService.findingId = data.FINDING_ID;
    this.router.navigate(['dashboard/auFindingDetails']);
  }

  getQmsCapaVwDetailsData: any = [];
  dateCustomClasses: DatepickerDateCustomClasses[];

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });

  }


  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  @ViewChild(SwitchuserComponent) switchUserComponent!: SwitchuserComponent;

  openSwitchUser(userBeingSwitched: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Assigned To") {
      this.message.switchedUser = this.selectedAssignedToUser;
      this.message.switchUserCurrentValue = this.selectedAssignedToUser;
      this.message.switchUserdropDownList = this.assignedToUserDropDown || []
    } else if (userBeingSwitched == "Response Reviewer") {
      this.message.switchedUser = this.selectedResponseReviewUser;
      this.message.switchUserCurrentValue = this.selectedResponseReviewUser;
      this.message.switchUserdropDownList = this.responseReviewDropdown;
    } else if (userBeingSwitched == "Implementation Reviewer") {
      this.message.switchedUser = this.selectedImplementationReviewerUser;
      this.message.switchUserCurrentValue = this.selectedImplementationReviewerUser;
      this.message.switchUserdropDownList = this.implementationReviewerDropdown
    }
    this.switchUserComponent.openswitchuser(userBeingSwitched, "Findings");
  }

  skipValidationsWhileSwitchingUser: boolean = false;
  onSwitchChildValueEmitted() {
    if (this.message.switchuserRole == "Assigned To") {
      this.selectedAssignedToUser = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Response Reviewer") {
      this.selectedResponseReviewUser = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Implementation Reviewer") {
      this.selectedImplementationReviewerUser = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.switchUserComponent.saveMethod();
    this.saveFindingDetails(this.findingsDetailsData);
    this.switchUserComponent.visibleswitchUserPopup.close();
    this.switchUserComponent.visibleConfirmationPopup.close();
  }

  getUsersForStages(taskStage: any): Observable<any> {
    return this.appService.getTaskStageUsers(taskStage['refNo'], 0, taskStage['stageName']).pipe(
      tap((stageUsers: any) => {
        if (taskStage['stageName'] == "Peer Review") {
          this.peerReviewersList = stageUsers?.map((user: any) => ({ userId: user.taskStageUsersPk.userId, userName: user.userName }));
          this.isPeerReviewer = this.peerReviewersList.some((peerReviewer: any) => peerReviewer.userId == +this.message.getUserId());
        }
      })
    );
  }

  auditorSectionFrozen: boolean = false;
  auditeeSectionFrozen: boolean = false;
  elite_primary_auditee: boolean = false; /* Special privilege for primary auditee to edit some fields in AUDITOR SECTION when its disabled */
  elite_assign_to_user_level_1: boolean = false; /* Special privilege for assign to user to edit some fields in AUDITOR SECTION  when its disabled → Open/Findings In Progress */
  elite_assign_to_user_level_2: boolean = false; /* Special privilege for assign to user to edit some fields in AUDITOR SECTION  when its disabled → Response Accepted/Implementation Pending/Findings In Progress */
  elite_response_reviewer: boolean = false; /* Special privilege for response reviewer to edit some fields in AUDITEE SECTION when its disabled */
  elite_actual_closed_date: boolean = false;
  elite_lead_auditor: boolean = false; /* Special privilege for assign to user to edit some fields in AUDITOR SECTION when its disabled */
  elite_peer_reviewer: boolean = false;/* Special privilege for peer reviewer to edit some fields in AUDITOR SECTION when its disabled */
  elite_freeze: boolean = false; /* Freezing Root Cause Analysis, Immediate Correction, Corrective Action, Preventive Action if CAPA added  */
  triggerFindingsAesthetic() {
    this.triggerAesthetic = false;

    const loggedUserId = this.message.getUserId();
    const status = this.findingsDetailsData.status + '/' + this.tempAuditStatus;
    const isLeadAuditor = this.auService.isAuditor;
    const isAssignToUser = this.findingsDetailsData.assignedToUser == loggedUserId;
    const isResponseReviewer = this.findingsDetailsData.responseReviewedByUser == loggedUserId;
    /* 'Implementation Reviewer have not used yet' const isImplementationReviewer = this.findingsDetailsData.implementationReviewedByUser == loggedUserId; */
    const isPrimaryAuditee = this.auService.isAuditee;
    const isPeerReviewer = this.isPeerReviewer;

    switch (status) {

      case 'Open/In Progress':
      case 'Open/In Progress/Received Q&A Response':
      case 'Open/Received Q&A Response':
      case 'Open/Peer Review Rejected':
      case 'Open/Closure Review Rejected':
      case 'Open/Closure Approval Rejected':
      case 'Open/Closure Approver Requested More Info.':
      case 'Open/Closure Reviewer Requested More Info.':
      case 'Open/Peer Reviewer Requested More Info.':
        this.auditorSectionFrozen = !isLeadAuditor;
        this.auditeeSectionFrozen = true;
        break;

      case 'Open/Findings In Progress':
      case 'Response Review Rejected/Findings In Progress':
      case 'Response Verification Rejected/Findings In Progress':
        this.auditorSectionFrozen = true;
        this.auditeeSectionFrozen = !(isPrimaryAuditee || isAssignToUser);
        break;

      case 'Open/Pending Peer Review':
      case 'Open/Peer Review Inprogress':
        this.auditorSectionFrozen = !isPeerReviewer;
        this.auditeeSectionFrozen = true;
        break;

      default:
        this.auditorSectionFrozen = true;
        this.auditeeSectionFrozen = true;
    }

    this.elite_primary_auditee = isPrimaryAuditee && (status == 'Open/Findings In Progress' || status == 'Response Review Rejected/Findings In Progress' || status == 'Response Verification Rejected/Findings In Progress')
    this.elite_assign_to_user_level_1 = isAssignToUser && (status == 'Open/Findings In Progress')
    this.elite_assign_to_user_level_2 = isAssignToUser && (status == 'Response Accepted/Implementation Pending/Findings In Progress' || status == 'Implementation Review Rejected/Findings In Progress' || status == 'Implementation Verification Rejected/Findings In Progress')
    this.elite_response_reviewer = isResponseReviewer && (status == 'Pending Response Review/Findings In Progress')
    this.elite_actual_closed_date = (isAssignToUser || isPrimaryAuditee) && (status == 'Open/Findings In Progress' || status == 'Response Review Rejected/Findings In Progress' || status == 'Response Verification Rejected/Findings In Progress' || status == 'Response Accepted/Implementation Pending/Findings In Progress' || status == 'Implementation Review Rejected/Findings In Progress' || status == "Implementation Verification Rejected/Findings In Progress")
    this.elite_lead_auditor = isLeadAuditor && (status == 'Pending Response Verification/Findings In Progress' || status == 'Pending Implementation Verification/Findings In Progress')
    this.elite_peer_reviewer = isPeerReviewer && (status == 'Open/Pending Peer Review' || status == 'Open/Peer Review InProgress')
    this.elite_freeze = this.findingsDetailsData.capaDetails;
  }

  showUpdateType: boolean = false;
  isUpdateType: boolean = false;

  private setUpdateType(status: string): void {

    const statuses = new Set([
      'Open/Findings In Progress',
      'Pending Response Verification/Findings In Progress',
      'Response Verification Rejected/Findings In Progress'
    ]);

    this.showUpdateType = !statuses.has(status) && this.auService.isAuditor;
    setTimeout(() => { this.isUpdateType = this.showUpdateType && this.auService.isAuditor; }, 1500);
  }

  @ViewChild(ModuletypeComponent) moduleTypeComponent!: ModuletypeComponent;
  openmoduleType: boolean = false;
  moduleTypeData: any;
  value: any;
  //openpopup
  openUpdateType() {
    this.moduleTypeData = {
      dropdownList: this.severityDropdown,
      moduleTypeValue: this.selectedSeverity,
      expcetedClosureOn: this.findingsDetailsData.expectedClosureDate,
      expectedToBeStartedOn: this.findingsDetailsData.dueDate,
      moduleName: this.dynamicLabel['SEVERITY'].fieldName,
      moduleStartedOnName: this.dynamicLabel['DUE_DATE'].fieldName,
      moduleclosedOnName: this.dynamicLabel['EXPECTED_CLOSURE_DATE'].fieldName
    }
    this.openmoduleType = true;
    this.moduleTypeComponent.openpopup(this.moduleTypeData);
  }

  skipValidation: boolean = false;
  onModuleTypeEmitted($event: any) {
    this.openmoduleType = false;
    this.selectedSeverity = $event.moduleType;
    this.findingsDetailsData.expectedClosureDate = $event.expcetedClosureOn;
    this.findingsDetailsData.dueDate = $event.expectedToBeStartedOn;
    this.qualityService.activity.typeUpdateJustification = $event.typeUpdateJustification;
    this.skipValidation = true;
    this.saveFindingDetails(this.findingsDetailsData);
  }


  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  manageValidations(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [manageValidations()] Id → ', elementId);
    });
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = (tempDiv.textContent ?? tempDiv.innerText) || '';
    return textContent.trim().length === 0;
  }

  private async factionOne(finding: any): Promise<void> {
    const validations = [
      { condition: !finding.findingShortDescription, id: 'short-description-validation' },
      { condition: !finding.finding || this.isContentEmpty(finding.finding), id: 'finding-validation' },
      { condition: !finding.reference.trim(), id: 'reference-validation' },
      { condition: !this.selectedSeverity, id: 'severity-validation' },
      { condition: !this.selectedAssignedToUser, id: 'assign-to-validation' },
      { condition: finding.isCapaRequired && !finding.capaNo, id: 'capa-validation' },
      { condition: (this.businessAreaDropdown.length ? !this.selectedBusinessArea.length : !finding.coreBusinessAreaName) && this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y' && finding.requestedAt, id: 'business-area' },

    ];
    await this.handleAsyncValidation(validations);
  }

  private async factionTwo(finding: any): Promise<void> {
    const validations = [
      { condition: !this.selectedAssignedToUser, id: 'assign-to-validation' },
      { condition: finding.isCapaRequired && !finding.capaNo, id: 'capa-validation' },
      { condition: !finding.isCapaRequired && (!finding.rootCauseAnalysis || this.isContentEmpty(finding.rootCauseAnalysis)), id: 'root-cause-validation' },
      { condition: !finding.isCapaRequired && (!finding.immediateCorrection || this.isContentEmpty(finding.immediateCorrection)), id: 'immediate-correction-validation' },
      { condition: !finding.isCapaRequired && (!finding.correctiveAction || this.isContentEmpty(finding.correctiveAction)), id: 'corrective-action-validation' },
      { condition: !finding.isCapaRequired && (!finding.preventiveAction || this.isContentEmpty(finding.preventiveAction)), id: 'preventive-action-validation' },
      { condition: finding.responseReviewedByUser != 0 && !this.selectedResponseReviewUser, id: 'response-reviewer-validation' },
      { condition: finding.implementationReviewedByUser != 0 && !finding.isCapaRequired && !this.selectedImplementationReviewerUser, id: 'implementation-reviewer-validation' }
    ];
    await this.handleAsyncValidation(validations);
  }

  private async factionThree(finding: any): Promise<void> {
    const validations = [
      { condition: !finding.isCapaRequired && (!finding.rootCauseAnalysis || this.isContentEmpty(finding.rootCauseAnalysis)), id: 'root-cause-validation' },
      { condition: !finding.isCapaRequired && (!finding.immediateCorrection || this.isContentEmpty(finding.immediateCorrection)), id: 'immediate-correction-validation' },
      { condition: !finding.isCapaRequired && (!finding.correctiveAction || this.isContentEmpty(finding.correctiveAction)), id: 'corrective-action-validation' },
      { condition: !finding.isCapaRequired && (!finding.preventiveAction || this.isContentEmpty(finding.preventiveAction)), id: 'preventive-action-validation' }
    ];
    await this.handleAsyncValidation(validations);
  }

  private async factionFour(finding: any): Promise<void> {
    const validations = [
      { condition: !finding.isCapaRequired && (!finding.rootCauseAnalysis || this.isContentEmpty(finding.rootCauseAnalysis)), id: 'root-cause-validation' },
      { condition: !finding.isCapaRequired && (!finding.immediateCorrection || this.isContentEmpty(finding.immediateCorrection)), id: 'immediate-correction-validation' },
      { condition: !finding.isCapaRequired && (!finding.correctiveAction || this.isContentEmpty(finding.correctiveAction)), id: 'corrective-action-validation' },
      { condition: !finding.isCapaRequired && (!finding.preventiveAction || this.isContentEmpty(finding.preventiveAction)), id: 'preventive-action-validation' },
      { condition: finding.responseReviewedByUser != 0 && !this.selectedResponseReviewUser, id: 'response-reviewer-validation' },
      { condition: finding.implementationReviewedByUser != 0 && !finding.isCapaRequired && !this.selectedImplementationReviewerUser, id: 'implementation-reviewer-validation' }
    ];
    await this.handleAsyncValidation(validations);
  }

  private async factionFive(finding: any): Promise<void> {
    const validations = [
      { condition: !finding.closureComments?.trim(), id: 'closure-comments-validation' }
    ];
    await this.handleAsyncValidation(validations);
  }

  private async factionSix(finding: any): Promise<void> {
    const validations = [
      { condition: !this.selectedAssignedToUser, id: 'assign-to-validation' },
      { condition: !finding.isCapaRequired && (!finding.rootCauseAnalysis || this.isContentEmpty(finding.rootCauseAnalysis)), id: 'root-cause-validation' },
      { condition: !finding.isCapaRequired && (!finding.immediateCorrection || this.isContentEmpty(finding.immediateCorrection)), id: 'immediate-correction-validation' },
      { condition: !finding.isCapaRequired && (!finding.correctiveAction || this.isContentEmpty(finding.correctiveAction)), id: 'corrective-action-validation' },
      { condition: !finding.isCapaRequired && (!finding.preventiveAction || this.isContentEmpty(finding.preventiveAction)), id: 'preventive-action-validation' },
      { condition: finding.responseReviewedByUser != 0 && !this.selectedResponseReviewUser, id: 'response-reviewer-validation' },
      { condition: finding.implementationReviewedByUser != 0 && !finding.isCapaRequired && !this.selectedImplementationReviewerUser, id: 'implementation-reviewer-validation' }
    ];
    await this.handleAsyncValidation(validations);
  }

  private async factionSeven(finding: any): Promise<void> {
    const validations = [
      { condition: finding.implementationReviewedByUser && !finding.isCapaRequired && !this.selectedImplementationReviewerUser, id: 'implementation-reviewer-validation' }
    ];
    await this.handleAsyncValidation(validations);
  }

  private async handleAsyncValidation(validations: { condition: boolean, id: string }[]): Promise<void> {
    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);
    this.qualityService.validatedFindingArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed');
    console.log(this.qualityService.validatedFindingArray, "Array")
    if (invalidIds.length > 0) {
      this.manageValidations(invalidIds);
      this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
    }
  }

  saveFindingDetails(finding: any) {
    return new Promise<boolean>((resolve) => {
      let validationPromises: Promise<void>[] = [];
      this.qualityService.validatedFindingArray = [];
      const status = this.findingsDetailsData.status + '/' + this.tempAuditStatus;

      if (!this.skipValidationsWhileSwitchingUser && !this.skipValidationForCAPA && !this.skipValidation) {
        if (['Open/In Progress', 'Open/In Progress/Received Q&A Response', 'Open/Received Q&A Response', 'Open/Peer Review Rejected', 'Open/Pending Peer Review'].includes(status)) {
          validationPromises.push(this.factionOne(finding));
        }

        if (['Open/Findings In Progress'].includes(status)) {
          validationPromises.push(this.factionTwo(finding));
        }

        if (['Pending Response Review/Findings In Progress'].includes(status)) {
          validationPromises.push(this.factionThree(finding));
        }

        if (['Response Review Rejected/Findings In Progress'].includes(status)) {
          validationPromises.push(this.factionFour(finding));
        }

        if (['Pending Response Verification/Findings In Progress', 'Pending Implementation Verification/Findings In Progress'].includes(status)) {
          validationPromises.push(this.factionFive(finding));
        }

        if (['Response Verification Rejected/Findings In Progress'].includes(status)) {
          validationPromises.push(this.factionSix(finding));
        }

        if (['Response Accepted/Implementation Pending/Findings In Progress', 'Implementation Review Rejected/Findings In Progress', ' Implementation Verification Rejected/Findings In Progress'].includes(status)) {
          validationPromises.push(this.factionSeven(finding));
        }

        if (['Pending Response Verification/Findings In Progress', 'Pending Implementation Verification/Findings In Progress'].includes(status)) {
          validationPromises.push(this.factionSix(finding));
        }

      }

      Promise.all(validationPromises).then(() => {
        const isValid = !this.qualityService.validatedFindingArray.some((result: string) => result === 'Failed');
        if (isValid) {
          this.prepareJson(finding);
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((error) => {
        console.error('Error occurred during validation:', error);
        resolve(false);
      })
    })
  }

  prepareJson(findingsData: any) {
    this.isProcessing = true;
    if (!findingsData.closureComments || this.isContentEmpty(findingsData.closureComments)) {
      findingsData.closureComments = null;
    }
    if (!findingsData.assignedToUserDetails || this.isContentEmpty(findingsData.assignedToUserDetails)) {
      findingsData.assignedToUserDetails = null;
    }
    if (!findingsData.comments || this.isContentEmpty(findingsData.comments)) {
      findingsData.comments = null;
    }
    if (!findingsData.reference || this.isContentEmpty(findingsData.reference)) {
      findingsData.reference = null;
    }
    const actualClosedDateValue = findingsData.actualClosedDate ? this.appService.dateZoneConvertion(new Date(findingsData.actualClosedDate)) : null;
    delete findingsData.createdOn;
    delete findingsData.updatedOn;

    let businessArea = null;
    if (this.dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y') {
      businessArea = this.businessAreaDropdown.length ? this.selectedBusinessArea?.join(',') : this.findingsData?.coreBusinessAreaName ?? null;
    }

    const obj = {
      auNo: this.message.activityId,
      seq: findingsData.seq,
      finding: findingsData.finding ?? null,
      findingShortDescription: findingsData.findingShortDescription ?? null,
      reference: findingsData.reference ?? null,
      deliverables: findingsData.deliverables ?? null,
      additionalDetails: findingsData.additionalDetails ?? null,
      severity: this.selectedSeverity ?? null,
      auditorComments: findingsData.auditorComments ?? null,
      additionalField: findingsData.additionalField ?? null,
      rootCauseAnalysis: findingsData.rootCauseAnalysis ?? null,
      immediateCorrection: findingsData.immediateCorrection ?? null,
      correctiveAction: findingsData.correctiveAction ?? null,
      preventiveAction: findingsData.preventiveAction ?? null,
      expectedCaClosureDate: findingsData.expectedCaClosureDate ? this.appService.dateZoneConvertion(new Date(findingsData.expectedCaClosureDate)) : null,
      expectedPaClosureDate: findingsData.expectedPaClosureDate ? this.appService.dateZoneConvertion(new Date(findingsData.expectedPaClosureDate)) : null,
      comments: findingsData.comments ?? null,
      assignedToUser: this.selectedAssignedToUser ?? null,
      assignedToDepartment: this.selectedAssignedToDepartment ?? null,
      expectedClosureDate: findingsData.expectedClosureDate ? this.appService.dateZoneConvertion(new Date(findingsData.expectedClosureDate)) : null,
      isCapaRequired: findingsData.isCapaRequired ? "Y" : "N",
      capaNo: (findingsData.capaNo || findingsData.isCapaRequired) ? findingsData.capaNo : null,
      dueDate: findingsData.dueDate ? this.appService.dateZoneConvertion(new Date(findingsData.dueDate)) : null,
      closureComments: findingsData.closureComments ?? null,
      assignedToUserDetails: findingsData.assignedToUserDetails ?? null,
      responseReviewedByUser: findingsData.responseReviewedByUser != 0 ? this.selectedResponseReviewUser : findingsData.responseReviewedByUser,
      implementationReviewedByUser: findingsData.implementationReviewedByUser != 0 ? this.selectedImplementationReviewerUser : findingsData.implementationReviewedByUser,
      actualClosedDate: findingsData.isCapaRequired == 'Y' ? null : actualClosedDateValue,
      requestedAt: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : findingsData.requestedAt,
      coreBusinessAreaName: this.dynamicLabel['REQUESTED_AT']?.isRemovable == 'Y' ? null : businessArea,
    }
    this.updateFindings(obj);
  }

  updateFindings(obj: any) {

    const modifiedData = {
      ...obj,
      findingId: this.auService.findingId
    }

    this.appService.updateAuFinding(modifiedData).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.isProcessing = false;
          this.ngOnInit();
          !this.skipValidationsWhileSwitchingUser && !this.triggeredThroughDynBtn && !this.skipValidationForCAPA && this.showSnackBar(Response.result, Response.resultType);
          this.skipValidationsWhileSwitchingUser && (this.skipValidationsWhileSwitchingUser = false);
          this.triggeredThroughDynBtn && (this.triggeredThroughDynBtn = false);
          if (this.skipValidationForCAPA) { this.cancelSearchCapaRequiredPopup(); this.skipValidationForCAPA = false; }
          this.skipValidation && (this.skipValidation = false);
        } else {
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  onIsCAPARequiredChange(e: any) {
    this.findingsDetailsData.capaDetails = this.findingsDetailsData.capaNo = null;
  }

  onSelect(event: any, id: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation(id, item);
    }
  }

  selectedColumns: any = [];
  reportObj: any = {};
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;

  excelPdfPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  manuallyPicked: boolean;
  pdfPageSizes: any = [];
  pdfPageSize: string = "";
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  columnLists: any = {};
  popupDataTitle: any = {};
  pdfDetailSearchText: string = '';
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportFooterFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  excelPdfSearchText: string = '';
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.dropDownForPdfColumn.length;
      });
    }
  }

  onSelect1() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }

  onDeSelect() {
    this.onSelect1();
  }

  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  openReportPopup(item: any) {
    if (item == 'Excel') {
      this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
      this.pdfPageSize = 'A4';
      this.columnLists = "Finding ID,Seq,Finding Short Description,Assigned To User Details,Assigned To,Status,Assigned To Department,Isolated CAPA required?,CAPA Details,Finding,Severity,Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Implementaiton Accepted?,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Final Risk Comments,Added By Parallel Workflow,Created On,Created By,Updated On,Updated By,Org ID,Au No.,CAPA No.,Assigned To,Response Reviewer,Implementation Reviewer,Created By,Updated By,Prim IDentifier";
      this.dropDownForPdfColumn = this.columnLists.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
      [this.isAllColumns, this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, false, []];
      this.isForExcel = item == 'Excel';
      this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
      const firstLevel = this.message.breadcrumbData.firstLevel;
      const secondLevel = this.message.breadcrumbData.secondLevel;
      const thirdLevel = this.message.breadcrumbData.thirdLevel;
      const fourthLevel = this.message.breadcrumbData.fourthLevel;
      let fileName = "";
      let after2ndSplit = [];

      if (firstLevel != null) { fileName = firstLevel + "_"; }

      if (secondLevel != null) {
        after2ndSplit = secondLevel.split(">");
        for (let index = 0; index < after2ndSplit.length; index++) {
          const element = after2ndSplit[index];
          fileName = fileName + element + "_";
        }
      }
      if (thirdLevel != null) { fileName = fileName + thirdLevel + "_"; }
      if (fourthLevel != null) { fileName = fileName + fourthLevel + "_"; }
      this.reportName = fileName + Date.now();
      this.selectBoxForFooter();
      this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
      this.isSaveReport = false;
    } else {
      this.openHeadReportPopup();
    }
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      console.log(vals.moduleList);
      if (vals.moduleList == "Common" || vals.moduleList.includes("AU")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistCode,
          displayExp: vals.codelistName
        });
      }
    }
  }

  generateReport(value: any) {
    console.log(value + "=====" + this.selectedColumns.length)
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      alert('Please select the Columns');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      const firstLevel = this.message.breadcrumbData.firstLevel;
      const secondLevel = this.message.breadcrumbData.secondLevel;
      const thirdLevel = this.message.breadcrumbData.thirdLevel;
      const fourthLevel = this.message.breadcrumbData.fourthLevel;
      let fileName = "";
      let after2ndSplit = [];

      if (firstLevel != null) { fileName = firstLevel + "_"; }
      if (secondLevel != null) {
        after2ndSplit = secondLevel.split(">");
        for (let index = 0; index < after2ndSplit.length; index++) {
          const element = after2ndSplit[index];
          fileName = fileName + element + "_";
        }
      }

      if (thirdLevel != null) { fileName = fileName + thirdLevel + "_"; }
      if (fourthLevel != null) { fileName = fileName + fourthLevel + "_"; }

      this.executeReport(value, after2ndSplit, fileName);
    }
  }

  executeReport(value: any, after2ndSplit: any, fileName: any) {


    if (value == 'Excel') {
      const pdfData = {

        blobColumnlist: "",
        clobColumnlist: "FINDING,ROOT_CAUSE_ANALYSIS,CORRECTIVE_ACTION,PREVENTIVE_ACTION,DELIVERABLES,COMMENTS,IMMEDIATE_CORRECTION,AUDITOR_COMMENTS,CLOSURE_COMMENTS",
        columnsList: "FINDING_ID,SEQ,FINDING_SHORT_DESCRIPTION,ASSIGNED_TO_USER_DETAILS,ASSIGNED_TO,STATUS,ASSIGNED_TO_DEPARTMENT,IS_CAPA_REQUIRED,CAPA_DETAILS,FINDING,SEVERITY,DUE_DATE,ROOT_CAUSE_ANALYSIS,CORRECTIVE_ACTION,PREVENTIVE_ACTION,DELIVERABLES,COMPLETED_ON,REFERENCE,COMMENTS,IMMEDIATE_CORRECTION,AUDITOR_COMMENTS,EXPECTED_CLOSURE_DATE,CLOSURE_COMMENTS,ACTUAL_CLOSED_DATE,RESPONSE_REVIEWER,RESPONSE_REVIEW_REQUESTED_ON,RESPONSE_REVIEW_COMPLETED_ON,RESPONSE_REVIEWER_COMMENTS,RESPONSE_REVIEW_STATUS,IMPLEMENTATION_REVIEWER,IMPLEMENTATION_REVIEW_REQUESTED_ON,IMPLEMENTATION_REVIEW_COMPLETED_ON,IMPLEMENTATION_REVIEWER_COMMENTS,IMPLEMENTATION_REVIEW_STATUS,IS_IMPLEMENTAITON_ACCEPTED,EXPECTED_PA_CLOSURE_DATE,EXPECTED_CA_CLOSURE_DATE,RESPONSE_VERIFICATION_REQUESTED_ON,RESPONSE_VERIFICATION_COMMENTS,RESPONSE_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_REQUESTED_ON,IMPLEMENTATION_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_COMMENTS,FINAL_RISK_SCORE,FINAL_RISK_STATUS,FINAL_RISK_COMMENTS,ADDED_BY_PARALLEL_WORKFLOW,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,ORG_ID,AU_NO,CAPA_NO,ASSIGNED_TO_USER,RESPONSE_REVIEWED_BY_USER,IMPLEMENTATION_REVIEWED_BY_USER,CREATED_BY,UPDATED_BY",
        columnsListarray: [],
        fieldColumnarray: [],
        reModule: "qmsFinding",
        fieldLabelsList: "Finding ID,Seq,Finding Short Description,Assigned To User Details,Assigned To,Status,Assigned To Department,Isolated CAPA required?,CAPA Details,Finding,Severity,Response Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Implementaiton Accepted?,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Final Risk Comments,Added By Parallel Workflow,Created On,Created By,Updated On,Updated By,Org ID,Au No.,CAPA No.,Assigned To,Response Reviewer,Implementation Reviewer,Created By,Updated By",
        fieldSizeList: "150,150,300,200,200,230,200,150,400,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,150,200,200,200,200,200,200,200,200,150,200,200,200,200,200,200,200,150,150,150,150,150,150,150,150,200",
        fieldSizeListArray: [],
        gridName: "QMS_AU_FINDINGS_VW",
        invisibleColumn: "ORG_ID,AU_NO,CAPA_NO,ASSIGNED_TO_USER,RESPONSE_REVIEWED_BY_USER,IMPLEMENTATION_REVIEWED_BY_USER,CREATED_BY,UPDATED_BY",
        invisibleColumnarray: [],
        manualEntryDataFields: null,
        orderByClause: "SEQ",
        tableOrViewName: "QMS_AU_FINDINGS_VW",
        groupId: this.qualityService.selectedActivityGroupId,
        wherVal: " Where FINDING_ID=" + this.auService.findingId,
        logoId: this.selectedReportLogoValue ?? null,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        footer: this.selectedReportFooter,
        reportName: this.reportName ?? "Finding_Report",
        currentStatus: "NA",
        groupName: "",
        chartStatus: "",
        module: "AU",
        codelistGroup: null,
        title: "Report",
        columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.dropDownForPdfColumn.slice(0, 10).map((column: any) => column.displayExp).join(','),
        pdfPageSize: this.pdfPageSize,
        informationTab: {
          "Report Name": after2ndSplit.length > 0 ? after2ndSplit[0] : "Change Request",
          "Exported By": localStorage.getItem("loggedUserName")
        }
      }
      this.appService.downloadexcelForChart(pdfData, fileName + Date.now() + ".xlsx");

    } else {
      const pdfData = {

        blobColumnlist: "",
        clobColumnlist: "FINDING,ROOT_CAUSE_ANALYSIS,CORRECTIVE_ACTION,PREVENTIVE_ACTION,DELIVERABLES,COMMENTS,IMMEDIATE_CORRECTION,AUDITOR_COMMENTS,CLOSURE_COMMENTS",
        columnsList: "FINDING_ID,SEQ,FINDING_SHORT_DESCRIPTION,ASSIGNED_TO_USER_DETAILS,ASSIGNED_TO,STATUS,ASSIGNED_TO_DEPARTMENT,IS_CAPA_REQUIRED,CAPA_DETAILS,FINDING,SEVERITY,DUE_DATE,ROOT_CAUSE_ANALYSIS,CORRECTIVE_ACTION,PREVENTIVE_ACTION,DELIVERABLES,COMPLETED_ON,REFERENCE,COMMENTS,IMMEDIATE_CORRECTION,AUDITOR_COMMENTS,EXPECTED_CLOSURE_DATE,CLOSURE_COMMENTS,ACTUAL_CLOSED_DATE,RESPONSE_REVIEWER,RESPONSE_REVIEW_REQUESTED_ON,RESPONSE_REVIEW_COMPLETED_ON,RESPONSE_REVIEWER_COMMENTS,RESPONSE_REVIEW_STATUS,IMPLEMENTATION_REVIEWER,IMPLEMENTATION_REVIEW_REQUESTED_ON,IMPLEMENTATION_REVIEW_COMPLETED_ON,IMPLEMENTATION_REVIEWER_COMMENTS,IMPLEMENTATION_REVIEW_STATUS,IS_IMPLEMENTAITON_ACCEPTED,EXPECTED_PA_CLOSURE_DATE,EXPECTED_CA_CLOSURE_DATE,RESPONSE_VERIFICATION_REQUESTED_ON,RESPONSE_VERIFICATION_COMMENTS,RESPONSE_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_REQUESTED_ON,IMPLEMENTATION_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_COMMENTS,FINAL_RISK_SCORE,FINAL_RISK_STATUS,FINAL_RISK_COMMENTS,ADDED_BY_PARALLEL_WORKFLOW,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,ORG_ID,AU_NO,CAPA_NO,ASSIGNED_TO_USER,RESPONSE_REVIEWED_BY_USER,IMPLEMENTATION_REVIEWED_BY_USER,CREATED_BY,UPDATED_BY",
        columnsListarray: [],
        fieldColumnarray: [],
        reModule: "qmsFinding",
        fieldLabelsList: "Finding ID,Seq,Finding Short Description,Assigned To User Details,Assigned To,Status,Assigned To Department,Isolated CAPA required?,CAPA Details,Finding,Severity,Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Implementaiton Accepted?,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Final Risk Comments,Added By Parallel Workflow,Created On,Created By,Updated On,Updated By,Org ID,Au No.,CAPA No.,Assigned To,Response Reviewer,Implementation Reviewer,Created By,Updated By",
        fieldSizeList: "150,150,300,200,200,230,200,150,400,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,200,150,200,200,200,200,200,200,200,200,150,200,200,200,200,200,200,200,150,150,150,150,150,150,150,150,200",
        fieldSizeListArray: [],
        gridName: "QMS_AU_FINDINGS_VW",
        invisibleColumn: "ORG_ID,AU_NO,CAPA_NO,ASSIGNED_TO_USER,RESPONSE_REVIEWED_BY_USER,IMPLEMENTATION_REVIEWED_BY_USER,CREATED_BY,UPDATED_BY",
        invisibleColumnarray: [],
        manualEntryDataFields: null,
        orderByClause: "SEQ",
        tableOrViewName: "QMS_AU_FINDINGS_VW",
        groupId: this.qualityService.selectedActivityGroupId,
        wherVal: " Where FINDING_ID=" + this.auService.findingId,
        logoId: this.selectedReportLogoValue ?? null,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        footer: this.selectedReportFooter,
        reportName: this.reportName ?? "Finding_Report",
        currentStatus: "NA",
        groupName: "",
        chartStatus: "",
        module: "AU",
        codelistGroup: null,
        title: "Report",
        columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.dropDownForPdfColumn.slice(0, 10).map((column: any) => column.displayExp).join(','), pdfPageSize: this.pdfPageSize
      }
      this.appService.downloadPdfForChart(pdfData, fileName + Date.now() + ".pdf");
    }
  }
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
  }
  //this.reportLogoDropdown = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  toggleAllSelection(value: any) {
    if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }
  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];
  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = [];
    for (let i = 0; i < this.dropDownDataForReportTemplate.length; i++) {
      if (this.dropDownDataForReportTemplate[i].subModule == 'AU-Finding') {
        this.reportTemplateDropdown = this.reportTemplateDropdown.concat({
          valueExp: this.dropDownDataForReportTemplate[i].qmsReportTemplateVwPk.templateId,
          displayExp: this.dropDownDataForReportTemplate[i].templateName
        });
      }
    }
  }
  templateid: number;
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.templateid = item;
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = '#005c8a';
      }

    }
  }
  // Export Report
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;
  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  onReportTemplateRemoved(item: any) {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue == null) {
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = 'red';
      }
    }
  };
  openHeadReportPopup() {
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    for (let i = 0; i < this.dropDownDataForReportTemplate.length; i++) {
      if (this.dropDownDataForReportTemplate[i].isDefault == 'Y') {
        this.selectedReportTemplateValue = this.dropDownDataForReportTemplate[i].qmsReportTemplateVwPk.templateId;
      }
    }
    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);

  }
  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  exportReportGenerateFuntion() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    console.log("this.selectedReportTemplateValue=", this.selectedReportTemplateValue);
    if (!this.selectedReportTemplateValue) {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    } else {
      let data: any = [];
      let data1: any = {};
      let genraldata: any = [];
      let y: number = +this.message.getUserId();
      this.findingsDetailsData.userId = y
      let genraldetails: any = {

      }

      genraldata.push(genraldetails)
      let templateName = this.reportTemplateDropdown.find((report: any) => this.selectedReportTemplateValue == report.valueExp);
      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.qualityService.selectedActivityGroupId.toString(),

        "gridName": "AU",
        "templateId": this.selectedReportTemplateValue ?? null,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "reportName": this.reportName ?? "Report",
        "currentStatus": this.findingsDetailsData.status,
        "groupName": thirdL[1],
        "templateName": this.selectedReportTemplateValue ?? null,
        "AUid": this.message.activityId,
        "AUId": this.auService.findingId.toString(),
        "FINDING_ID": this.auService.findingId,
        "Status": this.findingsDetailsData.status,
        "version": "0"

      }
      this.isProcessing = true;
      this.appService.genRateAUFindingReport(data1).subscribe((response: any) => {

        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const firstst = this.message.breadcrumbData.firstLevel;
        const secondnd = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;

        let fileName = "";
        if (firstst != null) {
          fileName = firstst + "_";
        }
        if (secondnd != null) {
          fileName = fileName + secondnd + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        console.log(Date.now())
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })

    }
  }

  exportReportCancelPopupFuntion() {
    this.visibleExportReportPopup.close();
  }
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  onCaClosureDateChange(date: Date) {
    if (date) {
      const caClosureDate = new Date(date);

      if (this.findingsDetailsData.expectedPaClosureDate && this.findingsDetailsData.expectedPaClosureDate < caClosureDate) {
        this.findingsDetailsData.expectedPaClosureDate = null;
      }
    } else {
      this.findingsDetailsData.expectedPaClosureDate = null;
    }
  }

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      4000: ['SHORT_DESCRIPTION']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

}
